import axios from 'axios'
import Vue from 'vue'

const state = {
    caseGroups: []
}

const getters = {
    getCaseGroups: state => state.caseGroups,
    // getCaseGroupName: function(id){
    //     var theCase = state.caseGroups.find(obj => obj.id == id);
    //     return theCase.name;
    // }
}

const actions = {
    async fetchCaseGroups({commit}){
        await axios.get('api/caseGroup')
            .then((response) => {
                commit('setCaseGroups', response.data)
                return Promise.resolve();
            })
            .catch((error) => {
                commit('setCaseGroups', [])
                return Promise.reject(error)
            })
    },
    async addCaseGroup({commit}, caseGroup){
        const response = await axios.post('/api/caseGroup', caseGroup)
        const newCaseGroup = response.data
        commit('addCaseGroup', newCaseGroup)
    },
    async updateCaseGroup({commit}, caseGroup){
        const response = await axios.put('/api/caseGroup', caseGroup)
        const editCaseGroup = response.data
        commit('editCaseGroup', editCaseGroup)
    },
    async deleteCaseGroup({commit}, caseGroup){
        await axios.delete('/api/caseGroup', { data: caseGroup })
        commit('deleteCaseGroup', caseGroup)
    }
}

const mutations = {
    setCaseGroups: (state, caseGroups) => (state.caseGroups = caseGroups),
    addCaseGroup: (state, caseGroup) => (state.caseGroups.push(caseGroup)),
    editCaseGroup: function (state, caseGroup) {
        var index = state.caseGroups.findIndex((obj => obj.id == caseGroup.id))
        Vue.set(state.caseGroups, index, caseGroup)
    },
    deleteCaseGroup: (state, caseGroup) => (state.caseGroups = state.caseGroups.filter(thisCaseGroup => thisCaseGroup.id !== caseGroup.id)),
}

export default {
    state,
    actions,
    mutations,
    getters
}